import type { Song } from "../types";

/** Ode to Joy (Beethoven, 1824 — public domain). */
export const odeToJoy: Song = {
  id: "ode-to-joy",
  title: "Ode to Joy",
  bpm: 110,
  instrument: "piano",
  notes: [
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1.5 },
    { key: "D4", beats: 0.5 },
    { key: "D4", beats: 2 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1.5 },
    { key: "C4", beats: 0.5 },
    { key: "C4", beats: 2 },
  ],
};
